<template>
<div class="card">
		<div class="grid">
		<div class="col-10">
			<h4>Evacuation Details</h4>
		</div>
		<div class="col-2">
			<InputSwitch v-model="showDetails" style="float:right" @change="onToggleDetails" />
		</div>
	</div>
	<div class="fluid grid" v-if="visibleDetails">
		<div class="field col-12 md:col-4">
			<label>Fire evacuation service type</label><br/>
			<Dropdown class="flex" v-model="receivedEvacuationData.fireEvacuationServiceType" :options="fireEvacuationServiceOptions" optionValue="value" optionLabel="label" />
		</div>
		<div class="field col-12 md:col-4">
			<label>Fire evacuation manual last updated</label><br/>
			<Calendar v-model="receivedEvacuationData.fireEvacuationManualLastUpdated" dateFormat="d M yy" :showIcon="true" :showButtonBar="true" class="w-100pc"  />
		</div>
		<div class="field col-12 md:col-4">
			<label>Warden training</label><br/>
			<Dropdown class="flex" v-model="receivedEvacuationData.wardenTraining" :options="wardenTrainingOptions" optionLabel="label" optionValue="value" />
		</div>
		<div class="field col-12 md:col-2">
			<label>NZFS approval required</label><br />
			<InputSwitch v-model="receivedEvacuationData.nzfsApprovalRequired" />
		</div>
		<div class="field col-12 md:col-3">
			<label>NZFS approval date</label><br />
			<Calendar v-model="receivedEvacuationData.nzfsApproval" dateFormat="d M yy" :showIcon="true" :showButtonBar="true" class="w-100pc" />
		</div>
		<div class="field col-12 md:col-3">
			<label>NZFS application date</label><br />
			<Calendar v-model="receivedEvacuationData.nzfApplicationDate" dateFormat="d M yy" :showIcon="true" :showButtonBar="true" class="w-100pc" />
		</div>
		<div class="field col-12 md:col-4">
			<label>Scheme reference</label>
			<InputText v-model="receivedEvacuationData.schemeReference" />
		</div>
		<div class="field col-12 md:col-6">
			<label>Fire alarm type</label><br/>
			<Dropdown class="flex" v-model="receivedEvacuationData.fireAlarmType" :options="fireAlarmOptions" optionLabel="label" optionValue="value" />
		</div>
		<div class="field col-12 md:col-6">
			<label>Security alarm type</label>
			<InputText v-model="receivedEvacuationData.securityAlarmType" />
		</div>
		<div class="field col-12 md:col-12">
			<label>Fire alarm panel located</label>
			<InputText v-model="receivedEvacuationData.fireAlarmPanelLocated" />
		</div>
		<div class="field col-12 md:col-6">
			<label>Fire alarm monitored by</label>
			<InputText v-model="receivedEvacuationData.fireAlarmMonitoredBy" />
		</div>
	</div>
</div>
</template>

<script lang="ts">
	import { Vue, Options } from 'vue-class-component';
	import { PropertyEvacuationData } from '../api-client/api-client'

	@Options({
		name: 'PropertyEvacuation',
		components: {
		},
		props: {
			receivedEvacuationData: PropertyEvacuationData,
		}
	})
	export default class PropertyEvacuation extends Vue {

		receivedEvacuationData = new PropertyEvacuationData();

		showDetails = false;

		fireEvacuationServiceOptions = [
			{ label: 'None', value: null },
			{ label: 'Evac Scheme with Trials', value: 'Evac Scheme with Trials' },
			{ label: 'Evac Scheme with Training only', value: 'Evac Scheme with Training only' },
			{ label: 'Evac Procedure Maintained', value: 'Evac Procedure Maintained' },
			{ label: 'Evac Procedure Non-Maintained', value: 'Evac Procedure Non-Maintained' }
		];

		wardenTrainingOptions = [
			{ label: 'None', value: null },
			{ label: 'With Trial Evacuation', value: 'With Trial Evacuation' },
			{ label: 'Seperate Warden Training', value: 'Seperate Warden Training' }
		];

		fireAlarmOptions = [
			{ label: 'None', value: null },
			{ label: 'Type 1', value: 'Type 1' },
			{ label: 'Type 2', value: 'Type 2' },
			{ label: 'Type 3', value: 'Type 3' },
			{ label: 'Type 4', value: 'Type 4' },
			{ label: 'Type 5', value: 'Type 5' },
			{ label: 'Type 6', value: 'Type 6' },
			{ label: 'Type 7', value: 'Type 7' },
			{ label: 'Security Alarm Only', value: 'Security Alarm Only' }
		];


		created() {
			this.showDetails = !this.emptyEvac;
		}

		onToggleDetails() {
			if (this.emptyEvac && !this.receivedEvacuationData) {
				this.$emit('updateEvacData', new PropertyEvacuationData());
			}
		}

		get emptyEvac() {
			if (!this.receivedEvacuationData) return true;

			return (this.receivedEvacuationData.fireEvacuationServiceType == null
				&& this.receivedEvacuationData.fireEvacuationManualLastUpdated == null
				&& this.receivedEvacuationData.wardenTraining == null
				&& this.receivedEvacuationData.nzfsApproval == null
				&& this.receivedEvacuationData.nzfApplicationDate == null
				&& this.receivedEvacuationData.securityAlarmType == null
				&& this.receivedEvacuationData.fireAlarmType == null
				&& this.receivedEvacuationData.fireAlarmPanelLocated == null
				&& this.receivedEvacuationData.schemeReference == null
				&& this.receivedEvacuationData.fireAlarmMonitoredBy == null) ? true : false;
		}

		get visibleDetails() {
			if (!this.receivedEvacuationData) {
				this.showDetails = false;
			}

			return this.showDetails;
		}
	}
</script>

<style scoped lang="scss">
</style>